var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCampaignsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.25V5.75H16V7.25H13ZM13.8542 13L11.3958 11.2917L12.2708 10.0625L14.7292 11.7708L13.8542 13ZM12.25 2.9375L11.3958 1.70833L13.8542 0L14.7083 1.22917L12.25 2.9375ZM2 12.5V8.5H1.5C1.08333 8.5 0.729167 8.35417 0.4375 8.0625C0.145833 7.77083 0 7.41667 0 7V6C0 5.58333 0.145833 5.22917 0.4375 4.9375C0.729167 4.64583 1.08333 4.5 1.5 4.5H4.39583L9 1.75V11.25L4.52083 8.5H4V12.5H2ZM10 8.9375V4.0625C10.3194 4.36806 10.566 4.73611 10.7396 5.16667C10.9132 5.59722 11 6.04167 11 6.5C11 6.95833 10.9132 7.40278 10.7396 7.83333C10.566 8.26389 10.3194 8.63194 10 8.9375Z",
    fill: "#5F11EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCampaignsActive);
export default __webpack_public_path__ + "static/media/icon-campaigns-active.2db8aa8d4fdc511eb339bb330f607ff4.svg";
export { ForwardRef as ReactComponent };